import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'bookings'

AdminRouter.addRoutes([
  {
    name: `${base}`,
    path: `/${base}`,
    component: {
      components: {
        index: () => import('./Index.vue'),
      },
      render(createElement) {
        return this.$account ? createElement('index') : null
      },
    },
    meta: {
      auth: true,
    },
  },
  {
    name: `${base}.tasks`,
    path: `/${base}/tasks`,
    component: () => import('./TaskIndex.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `${base}.create`,
    path: `/${base}/create`,
    component: () => import('./Create.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `${base}.edit`,
    path: `/${base}/:id/:action?`,
    component: () => import('./Edit.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `${base}.history`,
    path: `/${base}/:id/history`,
    component: () => import('./History.vue'),
    meta: {
      auth: true,
    },
  },
])

AdminSidebar.pushItem({
  id: `${base}`,
  order: 10,
  header: $vm => $vm.$t(`general.menu_main`),
  text($vm) {
    return $vm.$t(`${base}.title`)
  },
  route: {
    name: `${base}`,
  },
  icon: 'icon-stack',
  permission($vm) {
    return $vm.$allows('bookings.index') || $vm.$allows('bookings.serve')
  },
})

AdminSidebar.pushItem({
  id: `${base}.tasks`,
  order: 20,
  header: $vm => $vm.$t(`general.menu_main`),
  text($vm) {
    return $vm.$t(`${base}.jobs_title`)
  },
  route: {
    name: `${base}.tasks`,
  },
  icon: 'icon-stack',
  permission($vm) {
    return $vm.$allows('bookings.index') || $vm.$allows('bookings.serve')
  },
})

messageGroups.push(base)
messageGroups.push('enums')
messageGroups.push('widget')
messageGroups.push('vehiclelist')
messageGroups.push('airportslist')
messageGroups.push('orders')
